export const filterEmptyTranslations = (translations) => {
  return translations.map(tr => {
    if (!tr.title && tr.content?.length < 9) {
      return null
    }
    return { ...tr, published: true }
  }).filter(tr => !!tr)
}
